import React from "react";
import styled from "styled-components";
import { Link } from "gatsby";

const StyledButton = styled.div`
  background: ${(props) =>
    props.white ? "var(--white)" : "var(--light-to-dark)"};
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  width: fit-content;
  overflow: hidden;
  border-radius: ${(props) => (props.round ? "1.875rem" : "0.2rem")};
  border: ${(props) =>
    props.border
      ? "1px solid var(--bright-blue)"
      : !props.white && "2px solid var(--teal)"};
  height: ${(props) =>
    props.round ? "2.6rem" : props.large ? "4rem" : "2.875rem"};
  min-width: fit-content;
  transition: transform 0.3s;
  box-shadow: ${(props) => props.shadow && "var(--teal-shadow)"};

  &:hover {
    transform: ${(props) => (props.large ? "scale(1.03)" : "scale(1.05)")};
  }

  a,
  button {
    line-height: 100%;
    text-transform: uppercase;
    color: ${(props) => (props.white ? "var(--black)" : "var(--white)")};
    white-space: nowrap;
    width: 100%;
    padding: ${(props) => (props.round ? "0.5rem 1.85rem" : "0.88rem 1.5rem")};

    &:hover {
      color: ${(props) => (props.white ? "var(--teal)" : "var(--white)")};
    }
  }
`;

const Button = ({
  href,
  text,
  className,
  onClick,
  type,
  round,
  white,
  shadow,
  border,
  large,
}) => {
  return (
    <StyledButton
      className={`poppins-500 body-sm ${className}`}
      round={round}
      white={white}
      shadow={shadow}
      border={border}
      large={large}
    >
      {href ? (
        href[0] !== "/" ? (
          <a href={href} target="_blank" rel="noopener noreferrer">
            {text}
          </a>
        ) : (
          <Link to={href}>{text}</Link>
        )
      ) : (
        <button onClick={onClick} type={type}>
          {text}
        </button>
      )}
    </StyledButton>
  );
};

export default Button;
